module.exports = __webpack_public_path__ + "img/order-nor.0b3ab38f.svg";